<template>
  <img @click="previewImg" class="img" v-if="type === 'img'" :src="path" alt="" />
  <iframe v-else class="iframe" :src="path" frameborder="0"></iframe>
</template>

<script>
import { ImagePreview } from 'vant';

export default {
  data() {
    return {
      path: '',
    };
  },
  mounted() {
    this.type = this.$route.query.type;
    this.path = this.$route.query.path;
  },
  methods: {
    previewImg() {
      ImagePreview({
        images: [this.path],
        showIndex: true,
        loop: false, // 是否循环播放
        startPosition: 0,
      });
    },
  },

};
</script>

<style lang='scss' scoped>
.iframe {
  width: 100%;
  height: 100vh;
  box-sizing: border-box;
}

.img {
  display: block;
  width: 100%;
  // height: 100vh;
}
</style>
